module.exports = __webpack_public_path__ + "img/4.02.57d2a418.jpg";